// eslint-disable-next-line @typescript-eslint/no-empty-function
export const noop = () => {};

export const range = (size: number, startAt = 0): number[] => {
  return Array.from(Array(size).keys()).map((i) => i + startAt);
};
